export default "__VITE_ASSET__NhvVgsmN__"